import * as React from "react";
const SvgToggle01Left = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.965 12a3.965 3.965 0 1 0-7.93 0 3.965 3.965 0 0 0 7.93 0m2.07 0a6 6 0 0 1-1.487 3.965H17a3.965 3.965 0 1 0 0-7.93h-5.452A6 6 0 0 1 13.035 12m10 0A6.035 6.035 0 0 1 17 18.035H7a6.035 6.035 0 0 1-.31-12.062L7 5.965h10A6.035 6.035 0 0 1 23.035 12"
}));
export default SvgToggle01Left;
//# sourceMappingURL=Toggle01Left.js.map